import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4926e982&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4926e982')) {
      api.createRecord('4926e982', component.options)
    } else {
      api.reload('4926e982', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=4926e982&", function () {
      api.rerender('4926e982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/Edit.vue"
export default component.exports